import { render, staticRenderFns } from "./irrigatpush.vue?vue&type=template&id=1578979a&scoped=true&"
import script from "./irrigatpush.vue?vue&type=script&lang=js&"
export * from "./irrigatpush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578979a",
  null
  
)

export default component.exports